import React from 'react';
import PropTypes from 'prop-types';
import { List, Col } from '@sm/wds-react';

import './Submenu/nav-submenu.scss';

export const ByNeedColumn = ({ children }) => {
  return (
    <Col className="sm-nav-submenu__col">
      <List>{children}</List>
    </Col>
  );
};

export default ByNeedColumn;

ByNeedColumn.propTypes = {
  children: PropTypes.node.isRequired,
};
